import { FFmpeg } from '@ffmpeg/ffmpeg';
import { API_URL } from '../config';
// import { fetchFile } from '@ffmpeg/util';

export const fetchVoice = async (blobUrl, id, providerId) => {
    try {
        const response = await fetch(blobUrl);
        const wavBlob = await response.arrayBuffer();
        const mp3Data = await transcode(wavBlob)

        const url = `${API_URL}v1/voice_provider`;
        const formData = new FormData();
        // formData.append('file', wavBlob, 'voice.wav'); // 
        formData.append('file', new Blob([mp3Data.buffer], { type: 'video/mp3' }), 'voice.mp3')
        if (id) formData.append('thread_id', id);
        if (providerId) formData.append('provider_id', providerId);
        const res = await fetch(url, {
            method: 'POST',
            body: formData
        });
        return res.json();
    } catch (error) {
        console.log(error);
    }
};

export const fetchNewMessage = async (string, id) => {
    try {
        const url = `${API_URL}v1/new_message`;
        const formData = new FormData();
        formData.append('content', string);
        id && formData.append('thread_id', id)
        const res = await fetch(url, {
            method: 'POST',
            body: formData
        });
        return res.json();
    } catch (error) {
        console.log(error);
    }
};

export const fetchNewProviderMessage = async (string, id, providerId) => {
    try {
        const url = `${API_URL}v1/new_message_provider`;
        const formData = new FormData();
        formData.append('content', string);
        id && formData.append('thread_id', id)
        providerId && formData.append('provider_id', providerId)
        const res = await fetch(url, {
            method: 'POST',
            body: formData
        });
        return res.json();
    } catch (error) {
        console.log(error);
    }
};

export const fetchThreads = async (id) => {
    try {
        const url = `${API_URL}v1/threads`;
        const formData = new FormData();
        formData.append('thread_id', id)
        const res = await fetch(url, {
            method: 'POST',
            body: formData
        });
        return res.json();
    } catch (error) {
        console.log(error);
    }
};


export const fetchRuns = async (runId) => {
    try {
        const url = `${API_URL}v1/runs`;
        const formData = new FormData();
        formData.append('run_id', runId)
        const res = await fetch(url, {
            method: 'POST',
            body: formData
        });
        return res.json();
    } catch (error) {
        console.log(error);
    }
}

export const fetchFiles = async (runId) => {
    try {
        const url = `${API_URL}v1/files`;
        const formData = new FormData();
        formData.append('file_id', runId)
        const res = await fetch(url, {
            method: 'POST',
            body: formData
        });
        return res.json();
    } catch (error) {
        console.log(error);
    }
}



const transcode = async (url) => {
    const ffmpeg = new FFmpeg();
    await ffmpeg.load();
    await ffmpeg.writeFile("input.wav", new Uint8Array(url));
    await ffmpeg.exec(["-i", "input.wav", "output.mp3"]);
    const fileData = await ffmpeg.readFile('output.mp3');
    const data = new Uint8Array(fileData);
    return data;
};

export const fetchProviderData = async (providerName, stateId) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer c618bf5dbeaa926e1daf7eaa8ad9126f`);
  
    const formdata = new FormData();
    formdata.append("provider_name", providerName);
    formdata.append("state_id", stateId || "TX");
  
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
  
    const url = "https://www.powerlego.com/ApiGateway/v2/provider/get";
  
    const response = await fetch(url, requestOptions);
    return response.json();
  };
  